export default function PHP_localtime() {
  return (
    <div>
      <h1>PHP_localtime</h1>
    </div>
  );
}
